import React from "react";

const ReadIcon = ({ stroke = "#02C9A6" }) => (
  <svg
    width="26"
    height="26"
    viewBox="0 0 26 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.41696 19.9375C1.41696 20.386 1.78096 20.75 2.22946 20.75H13.7691C15.029 20.75 15.5003 20.3546 15.5003 19.0167V17.4513M1.41696 19.9375C1.41696 19.291 1.67377 18.671 2.13089 18.2139C2.58801 17.7568 3.208 17.5 3.85446 17.5H14.8525C15.0973 17.5 15.3132 17.4838 15.5003 17.4513M1.41696 19.9375V4.71667C1.41696 3.486 1.33896 2.12858 2.59996 1.48617C3.06363 1.25 3.67029 1.25 4.88363 1.25H14.8503C16.1893 1.25 16.5836 1.72342 16.5836 2.98333V15.7667C16.5836 16.8446 16.2781 17.3104 15.5003 17.4513"
      stroke={stroke}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.40039 9.18333L7.89431 10.8896C7.92652 10.9258 7.96641 10.9543 8.01107 10.9731C8.05572 10.9919 8.10402 11.0004 8.15241 10.9982C8.20081 10.9959 8.24808 10.9828 8.29077 10.9599C8.33346 10.937 8.37048 10.9048 8.39914 10.8657L11.4325 6.66675"
      stroke={stroke}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default ReadIcon;
